import React, { useEffect, useState } from "react";

const ThemeToggle = () => {
  const [theme, setTheme] = useState(null); // Börjar med null för att undvika onödig rendering

  useEffect(() => {
    try {
      if (typeof window !== "undefined") {
        const savedTheme = localStorage.getItem("theme") || "light";
        setTheme(savedTheme);
        document.body.className = savedTheme;
      }
    } catch (error) {
      console.error("Kunde inte läsa från localStorage:", error);
    }
  }, []);

  useEffect(() => {
    try {
      if (typeof window !== "undefined" && theme) {
        document.body.className = theme;
        localStorage.setItem("theme", theme);
      }
    } catch (error) {
      console.error("Kunde inte skriva till localStorage:", error);
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  if (!theme) {
    return null; // Rendera inget tills temat är laddat
  }

  return (
    <button
      onClick={toggleTheme}
      style={{
        position: "fixed",
        bottom: "1rem",
        right: "1rem",
        height: "2rem",
        width: "2rem",
        borderRadius: "50%",
        borderColor: "#ffce00",
        borderWidth: "3px",
        backgroundColor: theme === "light" ? "#53009c" : "#53009c",
        cursor: "pointer",
      }}
    >
      {theme === "light" ? "🌙" : "☀️"}
    </button>
  );
};

export default ThemeToggle;